// import dayjs from "dayjs";
// import { useQuery, useQueryClient } from "react-query";
// import { supabase } from "../../../config/supabaseClient";

// export function useLoadCustomContent(
//   username: any,
//   user_id: any,
//   postIds: any,
//   title: any,
//   order?: any
// ) {
//   const queryClient = useQueryClient();

//   async function getPaginatedFeed() {
//     let data,
//       error = null;
//     let finalData: any = [];
//     let post_ids = postIds;
//     // let post_ids = [...new Set(postIds?.split(","))];

//     const { data: content, error: contentError }: any = await supabase
//       .from(`${username}`)
//       .select("*")
//       .eq("user_id", user_id)
//       .in("post_id", post_ids)
//       .ilike("index", "%active%")
//       .order("post_date", { ascending: order === "ASC" ? true : false });


  
// finalData=[...content]
   
//     data = Array.from(
//       new Map(finalData.map((post: any) => [post.post_id, post])).values()
//     );
    
//     // Only sort by post_ids order when order is CUSTOM
//     // For ASC/DESC, keep the database sort order
//     if (order === "CUSTOM") {
//       data.sort(
//         (a: any, b: any) =>
//           post_ids.indexOf(a.post_id) - post_ids.indexOf(b.post_id)
//       );
//     }

//     error = contentError;

//     if (data && data.length >= 0 && Array.isArray(data)) {
//       return data;
//     } else if (error) {
//       throw new Error(error.message);
//     } else {
//       throw new Error("Failed to fetch posts");
//     }
//   }

//   // return useQuery(["customContent", user_id,title, postIds], getPaginatedFeed, {
//   //   refetchOnMount: true,
//   //   enabled:Boolean(title)  && Boolean(postIds),
//   // });
//   const queryResult = useQuery(
//     ["customContent", user_id, title, postIds, order],
//     getPaginatedFeed,
//     {
//       refetchOnMount: true,
//       refetchOnWindowFocus: true,
//       enabled:
//         Boolean(title) && Boolean(postIds) && Boolean(postIds.length >= 0),
//     }
//   );

//   // Force refetch if needed
//   const forceRefetch = () => {
//     queryClient.invalidateQueries(["customContent", user_id, title, postIds, order]);
//   };

//   return { ...queryResult, forceRefetch };
// }




import { useQuery, useQueryClient } from "react-query";
import { supabase } from "../../../config/supabaseClient";
import { useMemo } from "react";
import { StaticVariables } from "../../StaticVariables";
import { normalizeCustomContentPostIds } from "./normalizeCustomContentPostIds";
import {
  fetchShopLinkMap,
  filterPostsWithShopLinks,
} from "../../helpers/shoppableContent";

export function useLoadCustomContent(
  username: any,
  user_id: any,
  postIds: any,
  title: any,
  order?: any,
  custom_order?: any,
  activeFilter?: any,
  limit?: number,
  returnTotalCount?: boolean,
  shoppableStatusFilter?: string,
  enabled: boolean = true,
) {
  const queryClient = useQueryClient();
  
  // Support both 'order' and 'content_order' parameter names for backward compatibility
  const contentOrder = order;

  // Normalize postIds to array
  const normalizedPostIds = useMemo(
    () => normalizeCustomContentPostIds(postIds),
    [postIds],
  );

  // Normalize custom_order to array
  const normalizedCustomOrder = useMemo(() => {
    const ids = normalizeCustomContentPostIds(custom_order);
    return ids.length ? ids : null;
  }, [custom_order]);

  // Determine platforms array based on activeFilter
  const platforms = useMemo(() => {
    const staticVars = StaticVariables();
    if (activeFilter === "content") {
      return staticVars.CONTENT_PLATFORMS;
    } else if (activeFilter === "products") {
      return staticVars.PRODUCT_PLATFORMS;
    } else {
      // 'both' or default: all platforms
      return staticVars.PLATFORMS;
    }
  }, [activeFilter]);

  async function getPaginatedFeed() {
    // Ensure we have post IDs
    if (!normalizedPostIds || normalizedPostIds.length === 0) {
      if (returnTotalCount) {
        return { data: [], total_count: 0 };
      }
      return [];
    }

    // Match useLoadCustomContentInfinite: only pass custom_order for CUSTOM.
    // Passing pick ids with ASC/DESC makes the RPC keep pick order instead of
    // sorting by post_date (Newest/Oldest never visibly apply).
    const orderType = String(contentOrder || "DESC").toUpperCase();
    const fetchOrder = orderType === "CUSTOM" ? "DESC" : orderType;
    const { data: result, error } = await supabase.rpc("get_custom_content_orderedd", {
      userid: user_id,
      user_name: username,
      post_ids: normalizedPostIds,
      order_type: fetchOrder,
      custom_order: null,
      platforms: platforms, // Pass platforms array from code
      limit_num: limit || null,
      removed_post_ids: [] // Can be extended later if needed
    });

    if (error) {
      throw new Error(error.message);
    }

    // Extract data from RPC response
    let responseData = result?.data || result || [];
    if (shoppableStatusFilter && shoppableStatusFilter !== "all") {
      const shopLinkMap = await fetchShopLinkMap(
        username,
        String(user_id),
        responseData.map((post: any) => post?.post_id)
      );
      responseData = filterPostsWithShopLinks(
        responseData,
        shoppableStatusFilter,
        shopLinkMap
      );
    }
    const filteredData = responseData;
    const totalCount =
      shoppableStatusFilter && shoppableStatusFilter !== "all"
        ? filteredData.length
        : result?.total || 0;

    // Return structure based on returnTotalCount flag
    if (returnTotalCount) {
      return {
        data: filteredData,
        total_count: totalCount
      };
    }

    return filteredData;
  }

  // Serialize arrays for query key to ensure proper caching (copy before sort).
  const postIdsKey = useMemo(() => {
    return [...normalizedPostIds].sort().join(",");
  }, [normalizedPostIds]);

  // Serialize platforms for query key
  const platformsKey = useMemo(() => {
    return [...platforms].sort().join(",");
  }, [platforms]);

  const hasPostIds = normalizedPostIds.length > 0;
  const emptyResult = returnTotalCount
    ? { data: [], total_count: 0 }
    : [];

  const queryResult = useQuery(
    ["customContent", user_id, title, postIdsKey, String(contentOrder || "").toUpperCase() === "CUSTOM" ? "DESC" : contentOrder, platformsKey, limit, returnTotalCount, shoppableStatusFilter || "all"],
    getPaginatedFeed,
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      // Empty selection: no fetch — callers render empty immediately (no loader flash).
      enabled:
        Boolean(enabled) &&
        Boolean(title) &&
        hasPostIds &&
        Boolean(user_id),
      // Keep prior rows while ids shrink so the UI can filter client-side without a skeleton.
      // When selection is empty, do not keep prior rows (that left products on the canvas).
      keepPreviousData: hasPostIds,
      initialData: hasPostIds ? undefined : emptyResult,
      initialDataUpdatedAt: hasPostIds ? undefined : 0,
    }
  );

  // Force refetch if needed
  const forceRefetch = () => {
    queryClient.invalidateQueries([
      "customContent",
      user_id,
      title,
      postIdsKey,
      String(contentOrder || "").toUpperCase() === "CUSTOM" ? "DESC" : contentOrder,
      platformsKey,
      limit,
      returnTotalCount,
      shoppableStatusFilter || "all",
    ]);
  };

  const isCustomOrder = String(contentOrder || "").toUpperCase() === "CUSTOM";
  const data = useMemo(() => {
    const raw = queryResult.data;
    if (!isCustomOrder || !normalizedCustomOrder?.length || raw == null) return raw;
    const rank = new Map(
      normalizedCustomOrder.map((id, index) => [String(id), index]),
    );
    const sortRows = (rows: any[]) =>
      [...rows].sort((a, b) => {
        const left = rank.get(String(a?.post_id ?? ""));
        const right = rank.get(String(b?.post_id ?? ""));
        if (left == null && right == null) return 0;
        if (left == null) return 1;
        if (right == null) return -1;
        return left - right;
      });
    if (Array.isArray(raw)) return sortRows(raw);
    if (raw && Array.isArray((raw as { data?: any[] }).data)) {
      return { ...raw, data: sortRows((raw as { data: any[] }).data) };
    }
    return raw;
  }, [queryResult.data, isCustomOrder, normalizedCustomOrder]);

  return { ...queryResult, data, forceRefetch };
}